var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "#D6FDFF",
    stroke: "#1CA7AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.323 11.928C12.3977 11.928 12.463 11.9583 12.519 12.019L13.058 12.6C12.6473 13.076 12.148 13.447 11.56 13.713C10.9767 13.979 10.2697 14.112 9.439 14.112C8.72033 14.112 8.067 13.9883 7.479 13.741C6.891 13.489 6.38933 13.139 5.974 12.691C5.55867 12.2383 5.23667 11.697 5.008 11.067C4.77933 10.437 4.665 9.744 4.665 8.988C4.665 8.232 4.784 7.539 5.022 6.909C5.26 6.279 5.59367 5.73767 6.023 5.285C6.457 4.83233 6.975 4.48233 7.577 4.235C8.179 3.983 8.844 3.857 9.572 3.857C10.286 3.857 10.916 3.97133 11.462 4.2C12.008 4.42867 12.4887 4.739 12.904 5.131L12.456 5.754C12.428 5.80067 12.3907 5.84033 12.344 5.873C12.302 5.901 12.2437 5.915 12.169 5.915C12.085 5.915 11.9823 5.87067 11.861 5.782C11.7397 5.68867 11.581 5.586 11.385 5.474C11.189 5.362 10.944 5.26167 10.65 5.173C10.356 5.07967 9.99433 5.033 9.565 5.033C9.047 5.033 8.57333 5.124 8.144 5.306C7.71467 5.48333 7.34367 5.74233 7.031 6.083C6.723 6.42367 6.48267 6.839 6.31 7.329C6.13733 7.819 6.051 8.372 6.051 8.988C6.051 9.61333 6.13967 10.171 6.317 10.661C6.499 11.151 6.744 11.5663 7.052 11.907C7.36467 12.243 7.731 12.4997 8.151 12.677C8.57567 12.8543 9.033 12.943 9.523 12.943C9.82167 12.943 10.09 12.9267 10.328 12.894C10.5707 12.8567 10.7923 12.8007 10.993 12.726C11.1983 12.6513 11.3873 12.558 11.56 12.446C11.7373 12.3293 11.9123 12.1917 12.085 12.033C12.1643 11.963 12.2437 11.928 12.323 11.928Z",
    fill: "#1CA7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/CampaignIcon.1a176136bdc5028bcf693f019f5ca953.svg";
export { ForwardRef as ReactComponent };